import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "@phosphor-icons/react";

export default function LegalLayout({ eyebrow, title, effective, children }) {
  return (
    <div className="min-h-screen aurora grain">
      <header className="hairline-b">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center gold-glow" style={{ background: "#FFB020" }}>
              <ShieldCheck size={22} weight="duotone" color="#050B0A" />
            </div>
            <div>
              <div className="font-display text-lg leading-none">PerCen360</div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-white/50 mt-1">Compliance Finance OS</div>
            </div>
          </Link>
          <Link to="/" className="btn-ghost text-sm"><ArrowLeft size={14}/> Home</Link>
        </div>
      </header>

      <main className="max-w-[820px] mx-auto px-6 sm:px-10 py-16">
        <div className="eyebrow mb-3">{eyebrow}</div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight">{title}</h1>
        {effective && <div className="mt-4 text-sm text-white/50">{effective}</div>}
        <div className="mt-10 glass rounded-2xl p-8 sm:p-10 leading-relaxed text-white/80 space-y-6 legal-content">
          {children}
        </div>
        <div className="mt-8 text-xs text-white/40 flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white">Terms</Link>
          <Link to="/dpia" className="hover:text-white">DPIA Summary</Link>
          <span>Contact: gillian@percen360.com</span>
        </div>
      </main>
    </div>
  );
}
